import React, { useMemo } from 'react'
import { NavigationBar, NavigationBarProps, BDSProvider } from '@barracuda-internal/bds-core-v2'
import Home from '@barracuda-internal/bds-core-v2/dist/Icons/Core/Home'
import { ProductDataGlobalNavigationItem } from '@barracuda-internal/bds-core-v2/dist/UnifiedComponents/ProductSwitcher/types'
import { makeStyles } from '@material-ui/core/styles'

import { useFormatMessage } from 'global/lib/localization'

// Todo: Remove when we are able to remove MUI overrides
const useStyles = makeStyles(() => ({
  iconButton: {
    '& svg': {
      fontSize: '16px !important',
      zIndex: 3
    }
  }
}))

export interface NavBarProps extends NavigationBarProps {
  globalNavigation: ProductDataGlobalNavigationItem[]
}

const BASE_I18N_KEY = 'app.navbar'
const HOME_BUTTON_KEY = 'home-barracuda-one'

const NavBar = ({ logo, options, routes, currentPath, onNavigate, globalNavigation }: NavBarProps): JSX.Element => {
  const classes = useStyles()
  const formatMessage = useFormatMessage(BASE_I18N_KEY)

  const homeButtonOptions = globalNavigation.find(
    (option: ProductDataGlobalNavigationItem) => option.id === HOME_BUTTON_KEY
  )

  const navigationTopOptions = useMemo(() => {
    return homeButtonOptions?.showInNavigation && homeButtonOptions?.href
      ? [
          {
            name: formatMessage('home'),
            icon: <Home />,
            href: homeButtonOptions.href
          }
        ]
      : []
  }, [homeButtonOptions, formatMessage])

  return useMemo(
    () => (
      <BDSProvider useBdsTheme>
        <div className={classes.iconButton}>
          <NavigationBar
            logo={logo}
            options={options}
            routes={routes}
            currentPath={currentPath}
            onNavigate={onNavigate}
            topOptions={navigationTopOptions}
          />
        </div>
      </BDSProvider>
    ),
    [logo, options, routes, currentPath, onNavigate, navigationTopOptions, classes.iconButton]
  )
}

export default NavBar
